import { navigateBack } from 'actions/current_location/navigate_back';
import { getLookupAnalyticsProps } from './lib/lookup_result';

export default class LinkExternalCustomer {
  constructor(context) {
    this.context = context;
  }

  run({ externalProfile, customerId, selectionRank }) {
    const externalProfileDto = externalProfile.toJs();
    externalProfileDto.id = customerId;
    this.context.gateways.customerExtension.update(customerId, externalProfileDto);

    this.trackLinkAnalytics(customerId, selectionRank);
    this.setLinkRequested();

    navigateBack(this.context);
  }

  setLinkRequested() {
    let currentLocation = this.context.stores.currentLocation.get();
    if (currentLocation.setLinkRequested) {
      currentLocation.setLinkRequested();
    }
    this.context.stores.currentLocation.set(currentLocation);
  }

  trackLinkAnalytics(customerId, selectionRank) {
    const profile = this.context.stores.customers.storesFor(customerId).profile.get();
    const eventAction = !profile.externalCustomerId ? 'Linked' : 'Relinked';
    this.context.analytics.track(`Customer Profile Lookup - ${eventAction}`, {
      customerId,
      selectionRank,
      ...getLookupAnalyticsProps(this.context),
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/external_customer_lookup/link_external_customer.js